import axios, { AxiosInstance, AxiosRequestConfig } from "axios"
import { config } from "../config"
import { useCallback, useEffect, useState } from "react"
export let initialized = false
export const api: AxiosInstance = axios.create({
  baseURL: config.api.url,
  headers: {
    "X-ApiKey": config.api.key,
    "Content-Type": "application/json",
    Accept: "application/json, text/plain, */*",
  },
})
export let token: string | null = null

export function initApi(_token: string) {
  token = _token
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`
  initialized = true
}
export type UseApiData<TResponse> = [response: TResponse | null, error: Error | null, loading: boolean, retry: (data?: Record<string, unknown>) => void]

export function useApi<TResponse = any>(route: string, options?: AxiosRequestConfig & { lazy?: boolean; blockCall?: boolean , method?: string }): UseApiData<TResponse> {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<TResponse | null>(null)
  const [error, setError] = useState(null)
  const executeFetch = useCallback(
    (data?: Record<string, unknown>) => {
      const method: string = options?.method ?? "get"

      setLoading(true)
      setResponse(null)
      setError(null)

      if (!options?.blockCall) {
        api(route, { ...options, data, method })
          .then(({ data }) => setResponse(data))
          .catch(setError)
          .finally(() => setLoading(false))
      }
    },
    [JSON.stringify(options), route]
  )

  useEffect(() => {
    if (!options?.lazy) {
      executeFetch()
    }
  }, [JSON.stringify(options), executeFetch])

  return [response, error, loading, executeFetch]
}
